import { createContext } from 'react';

import { TAppPermissionsObj } from 'user/types';

export const AppPermissionsContext = createContext<
    TAppPermissionsObj | undefined
>(undefined);
